import React from 'react';
import { Link as v4Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import ActionMessageBox from 'app/shared/components/properties/ActionMessageBox';

const propTypes = {
    emailAddress: PropTypes.string,
};

const defaultProps = {
    emailAddress: 'example@zg.com',
};

const PendingEmailVerificationBox = (props) => {
    const { emailAddress, handleViewDetailsClick } = props;

    return (
        <ActionMessageBox>
            The listings associated with your account will be added once you verify your email at
            {' '}
            {emailAddress}
            .&nbsp;
            <Link
                reactRouterLink={v4Link}
                onClick={handleViewDetailsClick}
                className="ActionMessageBox-link"
            >
                View details.
            </Link>
        </ActionMessageBox>
    );
};

PendingEmailVerificationBox.propTypes = propTypes;
PendingEmailVerificationBox.defaultProps = defaultProps;

export default PendingEmailVerificationBox;
